import { useQuery } from '@tanstack/react-query'
import {
  SpendPerWorkerTimeseries,
  getSpendPerWorkerTimeseries,
} from 'api/pulse/spendPerWorkerTimeseries'
import { PulseFilters } from 'api/pulse'
import { getSpendPerWorkerTimeseriesKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useSpendPerWorkerTimeseries(query: PulseFilters) {
  return useQuery<SpendPerWorkerTimeseries>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getSpendPerWorkerTimeseriesKey(query),
    queryFn: ({ signal }) => getSpendPerWorkerTimeseries(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
